var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg050Tag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.981,0.002c-1.034-0.024-26.679,0-55.918,11.342c-34.506,13.385-60.211,36.895-75.129,68.487l-87.325-8.876 c-24.031-2.438-47.607,5.961-64.636,23.02L23.471,243.91c-31.112,31.164-31.101,81.861,0.024,113.013l131.287,131.394 c15.768,15.781,36.455,23.685,57.075,23.684c20.33-0.001,40.597-7.686,56.006-23.081c7.809-7.803,7.815-20.46,0.013-28.271 s-20.462-7.817-28.271-0.013c-15.443,15.428-40.808,15.169-56.539-0.579L51.778,328.663 c-15.563-15.576-15.569-40.924-0.051-56.467L202.228,122.26c8.534-8.549,20.326-12.748,32.338-11.53l101.817,10.348 c0.283,0.035,0.565,0.064,0.848,0.086l49.441,5.025l3.104,30.466c-35.462,13.167-69.069,15.245-69.893,15.293 c-11.018,0.588-19.478,9.992-18.898,21.012c0.562,10.668,9.388,18.941,19.947,18.941c0.354,0,0.71-0.009,1.066-0.028 c1.605-0.084,34.271-1.943,71.944-14.325l8.181,80.311c1.221,11.987-2.955,23.747-11.46,32.277l-76.838,75.408 c-7.88,7.733-7.998,20.39-0.266,28.27c7.733,7.88,20.39,7.998,28.27,0.266l76.906-75.475c0.042-0.042,0.085-0.083,0.127-0.125 c17.087-17.071,25.483-40.642,23.036-64.671l-9.428-92.54c52.068-27.796,79.418-70.781,79.386-125.292v-1 C511.857,24.662,487.195,0.001,456.981,0.002z M471.876,55.986L471.876,55.986c0.019,33.91-14.716,61.147-43.887,81.288 l-3.194-31.349c-0.963-9.44-8.427-16.903-17.867-17.863l-37.642-3.826c10.582-15.618,25.66-27.395,45.059-35.154 c22.334-8.934,42.319-9.099,42.538-9.1c8.267,0,14.993,6.726,14.993,14.993V55.986z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg050Tag);
export default __webpack_public_path__ + "static/media/050-tag.eccba3cdefc8c900ef03ede566e92726.svg";
export { ForwardRef as ReactComponent };